module.exports = __webpack_public_path__ + "static/media/AR_plain_no_letters_white.ad905331.png";